import { Fab, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import OpenFolder from '../../../../MyComponents/icons/OpenFolder';
import LoadFromLibraryIcon from '../../../../MyComponents/icons/LoadFromLibraryIcon';
import LoadImageIcon from '../../../../MyComponents/icons/LoadImageIcon';
import PdfBoardIcon from '../../../../MyComponents/icons/PdfBoardIcon';
import GoogleSearchImageIcon from '../../../../MyComponents/icons/GoogleSearchImageIcon';
import SectionChapter from '../../SectionChapter';

const OpenMenuManagement = ({ language, classes, refs }) => {
    let openMenu = [
        {
            id: 'tutorial.manageLesson.openMenu.explanation',
            children: (
                <Fab
                    size='small'
                    style={{ background: 'rgba(255,205,52,0.3)' }}
                    className={classes.sampleFab}
                >
                    <OpenFolder />
                </Fab>
            ),
        },
        {
            children: (
                <ul>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.loadFromLibrary'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <LoadFromLibraryIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.loadFromLibrary.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.uploadImage'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <LoadImageIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.uploadImage.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.loadPDF'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <PdfBoardIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.loadPDF.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                    <li>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.googleImages'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                            <GoogleSearchImageIcon className={classes.sampleFab} />
                        </Typography>
                        <Typography>
                            <FormattedMessage
                                id='tutorial.openMenu.googleImages.explanation'
                                values={{
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </Typography>
                    </li>
                </ul>
            ),
            img: [`/static/asset/img/tutorial/withText/${language.toUpperCase()}/OpenMenu.jpg`],
        },
    ];
    return (
        <SectionChapter
            refs={refs}
            id={'section-manageLesson-openMenu'}
            title={'tutorial.manageLesson.openMenu.title'}
            explanations={openMenu}
            imageTop={false}
        />
    );
};

export default OpenMenuManagement;
